import {
	formatMoney,
	formatMoneyShort,
} from '../helper';

import { IDCountries } from '../map-data-id';

export const transactionChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	legend: {
		display: true,
		labels: {
			boxWidth: 13,
		},
	},
};

export const commissionChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	legend: {
		display: true,
		labels: {
			boxWidth: 13,
		},
	},
};

export const revenueChartOptions = {
	legend: false,
	responsive: true,
	maintainAspectRatio: false,
	scales: {
		yAxes: [{
			ticks: {
				callback(value) {
					const formatted = formatMoneyShort(value);
					return formatted;
				},
			},
		}],
	},
	tooltips: {
		callbacks: {
			label(tooltipItem) {
				const label = formatMoney(tooltipItem.yLabel);
				return label;
			},
		},
	},
};

export const customerChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	cutoutPercentage: 35,
	title: {
		display: false,
		position: 'top',
		text: '',
		fontColor: '#717171',
		fontFamily: 'Roboto',
		fontSize: 12,
		fontStyle: 'thin',
	},
	legend: {
		display: true,
		position: 'left',
		labels: {
			boxWidth: 13,
			padding: 9.6,
		},
	},
};

// eslint-disable-next-line
export const customerMapChartOptions = datas => {
	return {
		chart: {
			borderWidth: 0,
		},
		title: {
			text: '',
		},
		subtitle: {
			// text: 'Demo of drawing all areas in the map, only highlighting partial data'
		},
		legend: {
			enabled: true,
			align: 'left',
			layout: 'vertical',
			verticalAlign: 'middle',
		},
		colorAxis: {
			min: 0,
			minColor: '#E6E7E8',
			maxColor: '#FA962B',
		},
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				align: 'left',
				verticalAlign: 'bottom',
			},
		},
		series: [{
			data: datas,
			mapData: IDCountries,
			name: 'Customer Location',
			cursor: 'pointer',
			states: {
				hover: {
					color: '#C8D7E1',
					borderColor: '#C8D7E1',
				},
			},
			dataLabels: {
				enabled: true,
				color: '#000',
				format: '{point.name}',
				style: {
					fontWeight: 'normal',
				},
			},
			// tooltip: {
			// 	valueSuffix: '/km²',
			// 	pointFormat: '{point.name}'
			// },
			// minSize: 4,
			// maxSize: '12%',
		}, {
			name: 'Separators',
			data: datas,
			// nullColor: 'gray',
			// nullColor: '#75CFD8',
			// showInLegend: false,
			// enableMouseTracking: false,
		}],
		credits: {
			enabled: false,
		},
	};
};

// eslint-disable-next-line
export const logisticsMapChartOptions = (datas, color = '#10a85c') => {
	const colorAxis = {
		min: 0,
		minColor: '#E6E7E8', // abu abu
		maxColor: color, // green
	};

	let maxData = 0;
	for (let i = 0; i < datas.length; i++) {
		const data = datas[i];
		const value = data[1];
		if (value > maxData) {
			maxData = value;
		}
	}

	if (maxData === 0) {
		colorAxis.max = 1;
	}

	return {
		chart: {
			borderWidth: 0,
		},
		title: {
			text: '',
		},
		subtitle: {
			// text: 'Demo of drawing all areas in the map, only highlighting partial data'
		},
		legend: {
			enabled: true,
			align: 'left',
			layout: 'vertical',
			verticalAlign: 'middle',
		},
		colorAxis,
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				align: 'left',
				verticalAlign: 'bottom',
			},
		},
		series: [{
			data: datas,
			mapData: IDCountries,
			name: 'Logistic Location',
			cursor: 'pointer',
			states: {
				hover: {
					color: '#C8D7E1',
					borderColor: '#C8D7E1',
				},
			},
			dataLabels: {
				enabled: true,
				color: '#000',
				format: '{point.name}',
				style: {
					fontWeight: 'normal',
				},
			},
		}, {
			name: 'Separators',
			data: datas,
		}],
		credits: {
			enabled: false,
		},
	};
};
